// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2FitS","head":"ProcedureTableInfo_head__1hnAH"};